module.exports = __webpack_public_path__ + "static/media/privacy-policy-hero.db945592.png";